import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var groupDetailsRes;
export const groupDetailsTodo = createAsyncThunk('groupDetails', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/view_group_details',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "group_id": id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return groupDetailsRes = res.data
    } catch (error) {
        return groupDetailsRes = error.response.data
    }
})


const groupDetailsSlice = createSlice({
    name: 'groupDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(groupDetailsTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('groupDetails', state.data)
            }
        });
        builder.addCase(groupDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default groupDetailsSlice.reducer; 